import angular from 'angular';

(function() {
    'use strict';
    angular.module('dashboard').factory('DepositorFilter', DepositorFilter);

    DepositorFilter.$inject = [];

    /* @ngInject */
    function DepositorFilter() {
        DepositorFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort
        };

        function DepositorFilter(depositorFilterData) {
            if (!depositorFilterData) {
                this.buildEmpty();
            } else {
                this.build(depositorFilterData);
            }
        }

        return DepositorFilter;

        /////////////////////

        function buildEmpty() {
            this.creationTimeFrom = null;
            this.creationTimeTo = null;
            this.antispamDateFrom = null;
            this.antispamDateTo = null;
            this.confirmNotifFrom = null;
            this.confirmNotifTo = null;
            this.emailNotif = null;
            this.spammer = null;
            this.name = null;
            this.email = null;
            this.confirmationOnly = false;
            this.pageCriteria = {
                pageSize: 20,
                page: 0,
                sorts: [{ direction: 'DESC', property: 'created' }]
            };
        }

        function build(depositorFilterData) {
            this.creationTimeFrom = depositorFilterData.creationTimeFrom || null;
            this.creationTimeTo = depositorFilterData.creationTimeTo || null;
            this.antispamDateFrom = depositorFilterData.antispamDateFrom || null;
            this.antispamDateTo = depositorFilterData.antispamDateTo || null;
            this.confirmNotifFrom = depositorFilterData.confirmNotifFrom || null;
            this.confirmNotifTo = depositorFilterData.confirmNotifTo || null;
            this.emailNotif = depositorFilterData.emailNotif || null;
            this.spammer = depositorFilterData.spammer || null;
            this.name = depositorFilterData.name || null;
            this.email = depositorFilterData.email || null;
            this.confirmationOnly = depositorFilterData.confirmationOnly;
            this.pageCriteria = {
                pageSize: depositorFilterData.pageCriteria.pageSize || 20,
                page: depositorFilterData.pageCriteria.page || 0,
                sorts: _setSort(depositorFilterData.pageCriteria.sorts)
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return [{ direction: 'DESC', property: 'created' }];
            }
            return sorts;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
